import { twMerge } from "tailwind-merge";

import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";

import FontAwesomeIcon from "components/FontAwesomeIcon";

import styles from "./style.module.scss";

interface Props {
  showLoading?: boolean;
  className?: string;
  inline?: boolean;
  children?: React.ReactNode;
}

export const SKSpinner = ({
  showLoading = true,
  className = "",
  inline,
  children,
}: Props) => {
  return (
    <div
      className={twMerge(
        styles.spinner,
        showLoading && styles.spinner_loading,
        inline && "inline-block",
        className
      )}
    >
      <FontAwesomeIcon icon={faSpinner} spin />
      {showLoading && (children || "Loading")}
    </div>
  );
};
